/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolPersonIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-person"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M12 11.7Q12 11.7 11.05 11.7Q10.1 11.7 8.78 10.38Q7.45 9.05 7.45 7.15Q7.45 5.25 8.78 3.92Q10.1 2.6 12 2.6Q13.9 2.6 15.22 3.92Q16.55 5.25 16.55 7.15Q16.55 9.05 15.22 10.38Q13.9 11.7 12 11.7ZM3.25 18.88L3.25 17.95Q3.25 16.93 3.74 16.1Q4.22 15.28 5.05 14.85Q6.7 14 8.45 13.57Q10.2 13.15 12 13.15Q13.8 13.15 15.55 13.57Q17.3 14 18.95 14.85Q19.77 15.28 20.26 16.1Q20.75 16.93 20.75 17.95L20.75 18.88Q20.75 20 19.99 20.76Q19.23 21.52 18.1 21.52L5.9 21.52Q4.78 21.52 4.01 20.76Q3.25 20 3.25 18.88Z" fill={color} />
    </svg>
  );
}
